/**
 * Description: Review section on review page for the Audit Tool. 
 */
import React from 'react';
import { OutfitBatch } from './outfitBatch.jsx';
import { JSClient } from '../common.jsx';
import '../../styles/reviewSection.css';
import { BATCH_SIZE } from '../constants.jsx';
import {AuditButton} from '../auditButton';
import {
    Alert
} from 'AWS-UI-Components-React';

export class ReviewSection extends React.Component {
  constructor(props) {
    super(props);
    this.AuditButton = React.createRef();
    this.state = { 
      user: this.props.user, 
      auditBatchResult: [],
      auditHistory: {},
      disableButtons: false,
      statusMsg: null
    };
    this.filter_options= {
      after_date: "",
      before_date: "",
      outfit_source: "",
      marketplace: "0",
      seed_category: ""
    }
    this.clientLoaded = this.clientLoaded.bind(this);
    this.getAuditBatchResultHandler = this.getAuditBatchResultHandler.bind(this);
    this.getAuditBatch = this.getAuditBatch.bind(this);
    this.cancelAuditBatch = this.cancelAuditBatch.bind(this);
    this.storeAuditBatch = this.storeAuditBatch.bind(this);
    this.postAuditBatch = this.postAuditBatch.bind(this);
    this.getNewAuditBatch = this.getNewAuditBatch.bind(this);
    this.saveAuditErrorCallback = this.saveAuditErrorCallback.bind(this);
    this.postAuditCallback = this.postAuditCallback.bind(this);
    this.numRequired = 0;
  }

  async getNewAuditBatch(filter_options) {
    await this.client.cancelAudit(this.state.user);
    return this.getAuditBatch(filter_options);
  }

  clientLoaded() {
    // If page was reload, show a batch
    if (this.state.user && window.performance 
      && performance.navigation.type === 1
      && this.props.filter_options.marketplace != "0") {
      this.getAuditBatch({marketplace: this.props.filter_options.marketplace});
    }         
  }

  componentWillMount() {
    this.client = new JSClient({ onReady: this.clientLoaded });
  }

  componentDidUpdate(prevProps, prevState) {
    this.setState((state, props) => {
      // reset status message if component did update with the exact same status message 
      if (prevState.statusMsg != null && prevState.statusMsg == this.state.statusMsg) {
        return ({
            statusMsg: null
        });
      }
    });
    // this.refs.review.scrollIntoView();
  }

  getAuditBatch(filter_options) {
    this.state.auditHistory.start_time = encodeURIComponent(new Date().toISOString());
        
    this.filter_options = { 
      after_date: filter_options.after_date, 
      before_date: filter_options.before_date,
      outfit_source: filter_options.outfit_source,
      marketplace: filter_options.marketplace,
      seed_category: filter_options.seed_category
    }
    return this.client.getAuditBatch(this.state.user, BATCH_SIZE, this.filter_options, this.getAuditBatchResultHandler);
  }

  /**Modifies outfit batch from datastore to handle audit information*/
  getAuditBatchResultHandler(getAuditBatchResult) {
    console.log(getAuditBatchResult);
    var outfits = getAuditBatchResult.outfits;
    this.setState({auditBatchResult: outfits ? outfits : []});

    for (let i = 0; i < this.state.auditBatchResult.length; i++) {
      this.state.auditBatchResult[i].audit_status = "Accepted"
      for (let j = 0; j < this.state.auditBatchResult[i].items.length; j++) {
        this.state.auditBatchResult[i].items[j].audit_status = "Accepted"
      }
    }
  }

  /**Updates auditBatchResult based on audit status of an item*/
  storeAuditBatch(batchNum, audit_status, flag, rejectionReasons, itemNum) {
    this.state.auditBatchResult[batchNum].items[itemNum].audit_status = audit_status;
    this.state.auditBatchResult[batchNum].items[itemNum].rejection_reason_list = rejectionReasons;

    const itemFlag = this.state.auditBatchResult[batchNum].items[itemNum].flag;
    if (itemFlag === undefined) {
      this.state.auditBatchResult[batchNum].items[itemNum].flag = flag;
      if(flag) {
        this.numRequired += 1;
      }
    } else if (itemFlag != flag) {
      this.state.auditBatchResult[batchNum].items[itemNum].flag = flag
      if (flag) {
        this.numRequired += 1;
      } else {
        this.numRequired -= 1;
      }
    }
    if (this.numRequired > 0) {
      this.AuditButton.current.changeFlag(true);
    } else {
      this.AuditButton.current.changeFlag(false);
    }
    console.log({ "audits": this.state.auditBatchResult })
  }

  /**Posts audit to central datastore */
  async postAuditBatch() {
    if (this.state.auditBatchResult.length == 0) {
      return null;
    }

    this.state.auditHistory.end_time = encodeURIComponent(new Date().toISOString());
    for (let i = 0; i < this.state.auditBatchResult.length; i++) {
      this.state.auditBatchResult[i].audit_user = this.state.user
    }

    await this.client.postAudit(this.state.auditBatchResult, this.state.auditHistory, this.postAuditCallback, this.saveAuditErrorCallback);
  }

  postAuditCallback(data) {
    return this.getAuditBatch(this.filter_options);
  }

  saveAuditErrorCallback(error) {
      this.setState((state, props) => {
          return ({
              statusMsg: <Alert
              header="Error saving outfits"
              content={`${error.response.data.message} (${new Date().toLocaleString()})`}
              type="error"
              ></Alert>
          });
      });
  }

  /** Calls cancelAuditBatch API */
  cancelAuditBatch() {
    return this.client.cancelAudit(this.state.user, this.getAuditBatchResultHandler);
  }

  render() {
    /**Review Content loads the outfits in a given batch */
    const ReviewContent = () => (
      <div>
        <div>
          {this.state.statusMsg}
        </div>
        <div>
          <OutfitBatch batch={this.state.auditBatchResult} storeAuditBatch={this.storeAuditBatch}/>
        </div>
        <div id="audit-buttons">
          <AuditButton
            text="Cancel Review"
            handler={this.cancelAuditBatch.bind(this)}
          />
          <AuditButton
            ref={this.AuditButton}
            text="Submit Batch"
            handler={this.postAuditBatch.bind(this)}
          />
        </div>
      </div>
    );

    return (
      <div ref="review">
        <ReviewContent/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reviewPage/reviewSection.jsx